<template>
<b-navbar-nav class="navbar-nav mr-auto">

  <b-nav-item @click="$store.getters['cmp/all']['tasks']['enabled']=true" class="status-indicator" v-if="project && project.workpack">
    <icon v-if="project.workpack.tasks.progress > 0" name="spinner" pulse />
    <b v-else-if="project.workpack.tasks.new > 0" class="success">{{project.workpack.tasks.new}}</b>
    <icon v-b-tooltip.hover title="Tasks" v-else name="circle" class="green"></icon>
  </b-nav-item>

  <!-- <b-nav-item v-b-tooltip.hover title="Project status" class="status-indicator" v-if="project && project.workpack" @click="showQa">
    <icon name="sun" class="yellow" v-if="qaPassed === 1"></icon>
    <icon name="sun" class="red" v-else-if="qaPassed === 0"></icon>
    <icon name="sun" class="gray" v-else></icon>
  </b-nav-item> -->
  <!-- <template v-if="project && project.workpack">
      <b-nav-item ref="overview" :id ="'btn_map_'+project.workpack.id" class="status-indicator" ><icon name="image"></icon></b-nav-item>
      <b-popover v-if="project.workpack" triggers="hover" :target="'btn_map_'+project.workpack.id">
        <template slot="default">
          <img width="250"
               :src="'/api/projects/preview-download/?workpack_id='+project.workpack.id"/>
        </template>
  </b-popover>
  </template> -->
  <!-- <b-nav-item v-b-tooltip.hover title="Project metrics" class="status-indicator" @click="showMetrics"><icon name="chart-line"></icon></b-nav-item> -->

  <b-container v-if="!noname" class="project-name">
    <b-button @click="gotoWorkpack" variant="link" class="btn-xs project-list-entry">
      {{'&nbsp;'.repeat(parseInt(level)) + project.name}}
    </b-button>
  </b-container>
  <template v-else>
      <b-container class="project-name">{{project ? project.name : 'No project selected' }}</b-container>
      <b-container v-b-tooltip.hover title="Open project browser" @click='toggleProjectList' class="w-5 project-browser-trigger pull-right">
        <icon name="angle-down"></icon>
      </b-container>
    </template>

</b-navbar-nav>
</template>

<script>
import ProjectsMatrics from './ProjectMatrics.vue'
import 'vue-awesome/icons/spinner'

export default {
  name: 'ProjectStats',
  props: {
    noname: {
      default: false
    },
    project: {
      default: null
    },
    level: {
      default: 0
    }
  },
  computed: {
    qaPassed() {
      if (!this.project || !this.project.workpack) {
        return -1
      }
      let qa = (this.project.workpack.qa || [])
      if (!qa.length) {
        return -1
      }
      return qa.filter(q => !q.passed).length > 0 ? 0 : 1
    },
    showProjectList: {
      get() {
        return this.$store.getters['project/showProjectList']
      },
      set(val) {
        this.$store.commit('project/showProjectList', val)
      },
    },
    dashboardEnabled () {
      return this.$store.getters['project/dashboardEnabled'] && this.$store.getters['project/dashboardEnabled']
    }
  },
  methods: {
    showQa() {
      let opts = {
        available: true,
        enabled: true,
        clazz: ProjectQa,
        w: 6,
        h: 6,
        x: 3,
        y: 0,
        propsData: {
          project: this.project
        },
        destroyable: true
      }

      this.$store.commit('cmp/update', {
        cmp: this.project['id'] + 'qa',
        payload: opts
      })
    },
    showMetrics() {
      let opts = {
        available: true,
        enabled: true,
        clazz: ProjectsMatrics,
        w: 6,
        h: 5,
        x: 3,
        y: 0,
        propsData: {
          project: this.project
        },
        destroyable: true
      }

      this.$store.commit('cmp/update', {
        cmp: this.project['id'] + 'metrics',
        payload: opts
      })
    },
    toggleProjectList() {
      this.showProjectList = !this.showProjectList
    },
    gotoWorkpack() {
      if (this.project.workpack) {
        if (this.dashboardEnabled) {
          location.href = `/dashboard/${this.project.workpack.id}`
        } else {
          location.href = `/${this.project.workpack.id}`
        }
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'This project has no workpack set up',
          type: 'error'
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/projects/ProjectStats.vue